import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ags-success-inscription',
  templateUrl: './success-inscription.component.html',
  styleUrls: ['./success-inscription.component.scss']
})
export class SuccessInscriptionComponent implements OnInit {
  public email: string;

  @Input('email') set _email(data) {
    this.email = data || '';
  }
  constructor(private router: Router) {}

  ngOnInit() {}

  goToHomePage() {
    this.router.navigate(['/'], {});
  }
}
